import { IChangeCategoryPositionState } from './changeCategoryPositionContext';
import { ChangeCategoryPositionActionTypes, TChangeCategoryPositionActions } from './changeCategoryPositionActions';

export const changeCategoryPositionReducer = (
	state: IChangeCategoryPositionState,
	action: TChangeCategoryPositionActions,
): IChangeCategoryPositionState => {
	switch (action.type) {
		case ChangeCategoryPositionActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				selectedRestaurant: null,
				positionsData: [],
			};
		case ChangeCategoryPositionActionTypes.SET_RESTAURANT:
			return {
				...state,
				selectedRestaurant: action.payload.selectedRestaurant,
				positionsData: [],
			};
		case ChangeCategoryPositionActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				selectedRestaurant: null,
				positionsData: [],
			};
		case ChangeCategoryPositionActionTypes.SET_POSITIONS_DATA:
			return {
				...state,
				positionsData: action.payload.positionsData,
			};
		case ChangeCategoryPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ChangeCategoryPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL:
			return {
				...state,
				isVisibleAdditionalRestaurantsModal: action.payload.isVisibleAdditionalRestaurantsModal,
				isApplyToOne: action.payload.isApplyToOne,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
				selectSearchString: action.payload.selectSearchString,
			};
		case ChangeCategoryPositionActionTypes.TOGGLE_APPLY_TO_ONE:
			return {
				...state,
				isApplyToOne: !state.isApplyToOne,
				selectedAdditionalRestaurants: [],
			};
		case ChangeCategoryPositionActionTypes.SET_ADDITIONAL_RESTAURANTS:
			return {
				...state,
				selectedAdditionalRestaurants: action.payload.selectedAdditionalRestaurants,
			};
		case ChangeCategoryPositionActionTypes.CHANGE_SELECT_SEARCH_STRING:
			return {
				...state,
				selectSearchString: action.payload.selectSearchString,
			};
		default:
			return state;
	}
};
